import { render, staticRenderFns } from "./ExportMessagesModal.vue?vue&type=template&id=2c34da5f"
import script from "./ExportMessagesModal.vue?vue&type=script&lang=js"
export * from "./ExportMessagesModal.vue?vue&type=script&lang=js"
import style0 from "./ExportMessagesModal.vue?vue&type=style&index=0&id=2c34da5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports